import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCustomTheme } from "./services/romReports";
import ProgressiveLoader from "./components/loader/ProgressiveLoader";
import { getParams } from "./utils/helpers";

const App = () => {
  const isLoading = useSelector((state) => state.global.loading);
  const [loadingTheme, setLoadingTheme] = useState(false);
  const { providerId, adminId, clientId } = getParams();
  getParams();
  useEffect(async () => {
    if (providerId && adminId && clientId) {
      await getCustomTheme()
        .then((res) => {
          sessionStorage.setItem(
            "customtheme",
            JSON.stringify(res?.data?.data),
          );
          document.documentElement.style.setProperty(
            "--primary-color",
            res?.data?.data?.primaryColorCode,
          );
          document.documentElement.style.setProperty(
            "--secondary-color",
            res?.data?.data?.secondaryColorCode,
          );
          setLoadingTheme(true);
        })
        .catch(() => {
          setLoadingTheme(true);
        });
    } else {
      setLoadingTheme(true);
    }
  }, []);
  //this useeffect is for fixing issue of page landing middle if we scorlled previous page .
  useEffect(() => {
    if (!isLoading) {
      window.scrollTo(0, 0);
    }
  }, [isLoading]);

  return (
    <>
      {loadingTheme && <Outlet />}
      {isLoading && <ProgressiveLoader loader={isLoading} />}
    </>
  );
};

export default App;
